import { QueryConfig } from "store/utils/query-config";

export const qcRuleGroupsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["-createdAt"],
  },
};
